class OperationsMap {
  styles = [
    {
      "featureType": "administrative",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#444444"
        }
      ]
    },
    {
      "featureType": "landscape",
      "elementType": "all",
      "stylers": [
        {
          "color": "#f2f2f2"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "all",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "all",
      "stylers": [
        {
          "saturation": -100
        },
        {
          "lightness": 45
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "all",
      "stylers": [
        {
          "visibility": "simplified"
        }
      ]
    },
    {
      "featureType": "road.arterial",
      "elementType": "labels.icon",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "transit",
      "elementType": "all",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "all",
      "stylers": [
        {
          "color": "#46bcec"
        },
        {
          "visibility": "on"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#d2e0e6"
        }
      ]
    }
  ];

  constructor() {
    const mapElement = document.querySelector('.js-operations-map');

    if (mapElement) {
      const map = new google.maps.Map(mapElement, {
        maxZoom: 18,
        zoom: 8.5,
        disableDefaultUI: true,
        styles: this.styles,
      });

      const bounds = new google.maps.LatLngBounds();

      const infoWindow = new google.maps.InfoWindow({
        content: '',
        disableAutoPan: true,
      });

      window.data.farms.map(farm => {
        const polygon = new google.maps.Polygon({
          map,
          paths: farm.acf.paths.map(path => ({
            lat: +path.lat,
            lng: +path.lng
          })),
          strokeColor: farm.acf.color,
          strokeOpacity: 1,
          strokeWeight: 1,
          fillColor: farm.acf.color,
          fillOpacity: 0.5,
        });

        const lat = farm.acf.paths.map(path => +path.lat).reduce((acc, current, _, { length }) => acc + current / length, 0);
        const lng = farm.acf.paths.map(path => +path.lng).reduce((acc, current, _, { length }) => acc + current / length, 0);

        farm.acf.paths.map(path => {
          bounds.extend({
            lat: +path.lat,
            lng: +path.lng,
          });
        });

        polygon.addListener('click', () => {
          infoWindow.setPosition({lat, lng});

          infoWindow.setContent(`
            <a class="operations-map__info" href="#operations-popup-${farm.post_title}">
              <div class="operations-map__name">${farm.post_title}</div>
              <div class="operations-map__label">Click to see details</div>
            </a>
          `);

          infoWindow.open(map);

          this.getPopupData(farm, 'farm');
        });
      });

      window.data.places.map(place => {
        const marker = new google.maps.Marker({
          map,
          position: {
            lat: +place.acf.marker.lat,
            lng: +place.acf.marker.lng,
          },
          icon: {
            url: '/wp-content/themes/Divi-child/images/marker.png',
          },
        });

        bounds.extend({
          lat: +place.acf.marker.lat,
          lng: +place.acf.marker.lng,
        });

        marker.addListener('click', () => {
          infoWindow.setContent(`
            <a class="operations-map__info" href="#operations-popup-${place.post_title}">
              <div class="operations-map__name">${place.post_title}</div>
              <div class="operations-map__label">Click to see details</div>
            </a>
          `);

          infoWindow.open(map, marker);

          this.getPopupData(place, 'place');
        });
      });

      map.fitBounds(bounds);

      location.hash = '';

      infoWindow.addListener('close', () => {
        location.hash = '';
      });
    }
  }

  getPopupData(data, type) {
    const farmItems = document.querySelectorAll('.js-farm');
    const placeItems = document.querySelectorAll('.js-place');

    if (type == 'farm') {
      farmItems.forEach(farm => farm.classList.remove('hidden'));
      placeItems.forEach(place => place.classList.add('hidden'));
    }

    if (type == 'place') {
      farmItems.forEach(farm => farm.classList.add('hidden'));
      placeItems.forEach(place => place.classList.remove('hidden'));
    }

    const fields = document.querySelectorAll('.js-farm-field');

    fields.forEach(field => {
      const src = field.dataset.src.split('.');

      if (field.nodeName == 'IMG') {
        field.src = '';

        if ( data[src[0]] && data[src[0]][src[1]] && data[src[0]][src[1]][src[2]] ) {
          field.src = data[src[0]][src[1]][src[2]];
        }
      }
      else {
        field.innerHTML = '';

        if ( data[src[0]] && data[src[0]][src[1]] ) {
          field.innerHTML = data[src[0]][src[1]];
        }
        else if ( data[src[0]] ) {
          field.innerHTML = data[src[0]];
        }
      }
    });

    const groups = document.querySelectorAll('.js-farm-group');

    groups.forEach(group => {
      const src = group.dataset.src.split('.');

      group.innerHTML = '';

      if ( data[src[0]] && data[src[0]][src[1]] ) {
        data[src[0]][src[1]].forEach(file => {
          const link = document.createElement('A');

          link.classList.add('operations-popup__documents__link');

          link.href = file.link.url;
          link.innerHTML = file.link.title;
          link.target = file.link.target;

          group.appendChild(link);
        });
      }
    });
  }
}

export default OperationsMap;
